export const heroCards = [
  { icon: '🏠', title: 'Residential Cleaning',      sub: 'Homes, Airbnb & Short-Lets' },
  { icon: '🏢', title: 'Commercial Cleaning',       sub: 'Offices, Hotels & Schools' },
  { icon: '✨', title: 'Deep & End of Tenancy',     sub: 'Thorough, move-in ready cleans' },
  { icon: '📞', title: 'Free Consultation',         sub: 'Competitive & negotiable rates' },
];

export const stats = [
  { num: '7+',   label: 'Service categories' },
  { num: '100%', label: 'Satisfaction focus' },
  { num: '✓',   label: 'Flexible & negotiable rates' },
  { num: '24/7', label: 'Availability upon request' },
];

export const services = [
  { icon: '🔑', name: 'End of Tenancy Cleaning',      desc: 'Deep, thorough cleaning to meet landlord standards and ensure full deposit returns.' },
  { icon: '🏡', name: 'Airbnb & Short-Let Cleaning',  desc: 'Fast turnovers and impeccable presentation for short-term rental properties.' },
  { icon: '✨', name: 'Deep Cleaning',                desc: 'A comprehensive clean targeting hidden dirt, grease, and buildup in every corner.' },
  { icon: '🏠', name: 'Residential Cleaning',         desc: 'Regular or one-off home cleaning tailored to your schedule and preferences.' },
  { icon: '🏢', name: 'Office & Commercial Cleaning', desc: 'Professional, discreet cleaning for offices, retail spaces, and commercial premises.' },
  { icon: '🎓', name: 'Schools & Places of Worship',  desc: 'Safe, hygienic cleaning for educational institutions and sacred community spaces.' },
  { icon: '🏨', name: 'Hotels & Guest Houses',        desc: 'Hospitality-grade cleaning that keeps your guests coming back.' },
];

export const reasons = [
  { title: 'Customer satisfaction is our top priority',   sub: 'We go above and beyond to ensure every client is delighted.' },
  { title: 'Reliable and detail-focused cleaning',        sub: 'We never cut corners — every surface gets the attention it deserves.' },
  { title: 'Honest service with integrity and excellence',sub: 'Transparency and professionalism underpin everything we do.' },
  { title: 'Competitive and negotiable rates',            sub: 'Quality cleaning that fits your budget, always.' },
  { title: 'Flexible services tailored to your needs',    sub: 'We work around your schedule, not the other way around.' },
];

export const serviceOptions = [
  'End of Tenancy Cleaning',
  'Airbnb & Short-Let Cleaning',
  'Deep Cleaning',
  'Residential Cleaning',
  'Office & Commercial Cleaning',
  'Schools & Places of Worship',
  'Hotels & Guest Houses',
  'Other / Not Sure',
];

export const coverageAreas = [
  {
    region: 'Merseyside',
    icon: '🏙️',
    colour: 'sage',
    places: [
      'Liverpool', 'Wirral', 'Birkenhead', 'Wallasey', 'Bebington',
      'Knowsley', 'St Helens', 'Sefton', 'Bootle', 'Southport',
    ],
  },
  {
    region: 'Cheshire',
    icon: '🌿',
    colour: 'gold',
    places: [
      'Chester', 'Warrington', 'Crewe', 'Macclesfield', 'Ellesmere Port',
      'Runcorn', 'Widnes', 'Northwich', 'Congleton', 'Nantwich',
    ],
  },
  {
    region: 'Greater Manchester',
    icon: '🏛️',
    colour: 'ink',
    places: [
      'Manchester City Centre', 'Salford', 'Stockport', 'Oldham',
      'Bolton', 'Wigan', 'Trafford', 'Bury', 'Rochdale', 'Tameside',
    ],
  },
];

export const contactInfo = [
  { href: 'tel:07926395614',              icon: '📞', label: 'Phone',   val: '07926 395614' },
  { href: 'mailto:admin@freshwavesolutionsltd.co.uk', icon: '✉️', label: 'Email',   val: 'admin@freshwavesolutionsltd.co.uk' },
  { href: null,                           icon: '📍', label: 'Address', val: 'Unit 1G Wavertree Boulevard South, L7 9PF' },
];
